module.exports = { "default": require("core-js/library/fn/object/is-frozen"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/is-frozen.js
// module id = 768
// module chunks = 14